export default {
  taxuallyLinkText: {
    id: 'bo_seller_profile_page_epr_block_taxually_link_text',
    defaultMessage: 'Benefit from discounted rates with our partner Taxually',
  },
  needHelp: {
    id: 'bo_seller_profile_page_epr_block_need_help',
    defaultMessage: 'Need help with your EPR registration?',
  },
}
